import React, {useEffect} from 'react';
import 'components/ConnectPage.styl';
import {IntegrationCardListContainer} from '@components/integrations/IntegrationCardListContainer';
import {Router, RouterComponentProps, RouterLocation} from '@store/@types/util/ReactRouter';
import ToastStore from '@store/toast/ToastStore';

interface ConnectPageProps extends RouterComponentProps {}

/**
 * Replace the router location, removing the query string (and, incidentally, the state, which we don't use here).
 */
const clearQuery = (location: RouterLocation, router: Router) => {
  router.replace({
    pathname: location.pathname,
  });
};

/**
 * Pop up a toast notification indicating success/failure of integration setup.
 *
 * Currently only used for the zoom/recall note taker integration.
 *
 * @param result Result of integration setup.
 */
const toast = (result: 'success' | 'failed') => {
  if (result === 'success') {
    ToastStore.addToast({
      message: 'Mediafly Notetaker for Zoom successfully connected',
    });
  } else {
    ToastStore.addToast({
      message: 'We encountered an error establishing the connection. Please try again.',
      type: 'error',
    });
  }
};

const CardList = () => {
  // TODO figure out how to make this thing stop complaining about missing props reasonably.
  // @ts-ignore
  return <IntegrationCardListContainer />;
};

/**
 * List of integrations and their status.
 *
 * Admins can connect various integrations here.
 */
export const ConnectPage: React.FC<ConnectPageProps> = ({location, router}) => {
  const {query} = location;

  // Not great that we have to resort to an effect, but we get a big old warning (conveniently logged with
  // console.error) about calling setState during render without this. I have to assume newer react router versions
  // have better ways of dealing with this.
  useEffect(() => {
    if (!!query.result) {
      clearQuery(location, router);
    }
  });

  // If the query string indicates we should display results, do so. The effect will clear the query string so that the
  // toast isn't repeated.
  if (query.result === 'success' || query.result === 'failed') {
    toast(query.result);
  }

  // The effect is going to replace the browser history. Bail early.
  if (!!query.result) {
    return null;
  }

  return (
    <div className="oauth-page">
      <div>
        <h1>Configure Coach Integrations</h1>
      </div>
      <CardList />
    </div>
  );
};
